import { Component, EventEmitter, Input, Output } from '@angular/core';
import _ from 'lodash';

@Component({
    standalone: false,
    selector: 'sm-toast',
    templateUrl: './sm-toast.component.html',
    styleUrls: ['./sm-toast.component.scss'],
})

export class SmToastComponent {
    @Input() toast: SmToast;
    @Input() standalone: boolean = false;

    @Output() onClickLink: EventEmitter<SmToastClickLinkEvent> = new EventEmitter();
    @Output() dismiss: EventEmitter<any> = new EventEmitter();
}

export class SmToast {
    public Id: string;
    public Type: SmToastType = SmToastType.Info;
    public Icon: string;
    public Message: string = "";
    public Subtitles: SmToastSubtitle[] = [];
    public Description: string = "";
    public Links: SmToastSubtitle[] = [];

    constructor(id: string, type: SmToastType, message: string, subtitlesAndLinks: SmToastSubtitle[], description: string) {
        this.Id = id;
        this.Type = type;
        this.Message = message;
        this.Description = description;

        this.Subtitles = _.filter(subtitlesAndLinks, s => !s.IsLink);
        this.Links = _.filter(subtitlesAndLinks, s => s.IsLink);

        switch (this.Type) {
            case 'error':
                this.Icon = 'error-fill';
                break;
            case 'warning':
                this.Icon = 'warning-fill';
                break;
            case 'success':
                this.Icon = 'checkmark-circle-fill';
                break;
            case 'announcement':
                this.Icon = 'megaphone-fill';
                break;
            default:
                this.Icon = 'information-fill';
        }
    }
}

export interface SmToastSubtitle {
    Type: string;
    DisplayType?: string;
    Text: string;
    IsLink?: boolean;
    LinkIds?: { [key: string]: string };
}

export enum SmToastType {
    Info = 'info',
    Announcement = 'announcement',
    Error = 'error',
    Warning = 'warning',
    Success = 'success'
}

export interface SmToastClickLinkEvent {
    Id: string; // Toast Id
    Subtitle: SmToastSubtitle;
}